
import { priorCountryOptions, objectCountries, stateAndCounty } from 'components/helper/stateAndCounty';
import DatePickerInput from 'components/input/DatePicker';
import SelectInput from 'components/input/SelectInput';
import YesNoSwitch from 'components/input/YesNoSwitch';
import familyServices from 'services/familyServices';
import Grid from '@mui/joy/Grid';
// import { csuCountry } from 'components/helper/helper';
// import moment from 'moment';
// import React from 'react';
// import { Row } from 'react-bootstrap';

type Props = {
  formik: any;
  check?: any;
  isMobile?: boolean;
  disabled?: boolean;
};

const Residency = ({ formik, check, 
  //isMobile = false, 
  disabled = false }: Props) => {
  const getStatesCSU = (country_id: any) => {
    formik.setFieldValue('csu_info.priorState', 'Select a State/Province');
    familyServices
      .getStatesCSU(country_id)
      .then((res: any) => {
        let csuStateTemp: any[] = [];
        res.data.forEach((item: any) => {
          csuStateTemp.push(item.name);
        });
        formik.setFieldValue('csu_info.priorStateOptions', csuStateTemp);
      })
      .catch((err: any) => {
        console.log('Error:', err);
        //return err;
      });
  };

  const handlePriorCountryChange = (event: any) => {
    const { name, value } = event.target;
    if (name === 'csu_info.priorCountry') {
      const country = objectCountries.find(
        (item: any) => item.name === value
      );
      if (country) {
        const country_id = country.id;
        getStatesCSU(country_id);
      }
    }
    formik.handleChange(event);
  };

  const isCaliforniaResident = formik.values.csu_info?.isCurrentPermanentResidentOfCalifornia === 'true';
  // Only meaningful (and visible) when the parent/guardian is a California permanent resident.
  const notLivedSinceBirth =
    isCaliforniaResident && formik.values.csu_info?.isLivedInCaliforniaContinuouslySinceBirth === 'false';
  const isNotCaliforniaResident = formik.values.csu_info?.isCurrentPermanentResidentOfCalifornia === 'false';

  // Fields that only apply when the answer is "Yes". They are cleared when the answer becomes "No".
  const handleCaliforniaResidentChange = (event: any) => {
    formik.handleChange(event);
    if (event?.target?.value === 'false') {
      formik.setFieldValue('csu_info.isLivedInCaliforniaContinuouslySinceBirth', '');
      formik.setFieldValue('csu_info.whenStayInCaliforniaBegin', '');
      formik.setFieldValue('csu_info.priorCountry', '');
      formik.setFieldValue('csu_info.priorState', '');
      formik.setFieldValue('csu_info.priorStateOptions', []);
      formik.setFieldValue('csu_info.fromWhenToWhenLiveThere', '');
      formik.setFieldValue('csu_info.ToWhenToWhenLiveThere', '');
    }
  };
  
  return (
    <>
      <Grid xs={12}>
        <div className="text-dart fs-5 span-csu-logo">Residency</div>
      </Grid>

      <Grid xs={12}>
        <YesNoSwitch
          label="Is your parent/guardian a current permanent resident of California?*"
          values={formik.values.csu_info?.isCurrentPermanentResidentOfCalifornia}
          name="csu_info.isCurrentPermanentResidentOfCalifornia"
          onChange={handleCaliforniaResidentChange}
          isMissing={!formik.values.csu_info?.isCurrentPermanentResidentOfCalifornia && check}
          disabled={disabled}
        />
      </Grid>

      {isNotCaliforniaResident && (
        <Grid xs={12} md={6}>
          <SelectInput
            label="Which U.S. State/possession does your parent/guardian regard as her permanent home?"
            option={Object.keys(stateAndCounty)}
            values={formik.values.csu_info?.stateRegardAsPermanentHome}
            name="csu_info.stateRegardAsPermanentHome"
            onChange={formik.handleChange}
            disabled={disabled}
          />
        </Grid>
      )}
      
      {isCaliforniaResident && (
        <Grid xs={12}>
          <YesNoSwitch
            label="Has your parent/guardian lived in California continuously since birth?*"
            values={formik.values.csu_info?.isLivedInCaliforniaContinuouslySinceBirth}
            name="csu_info.isLivedInCaliforniaContinuouslySinceBirth"
            onChange={formik.handleChange}
            isMissing={
              (formik.values.csu_info?.isLivedInCaliforniaContinuouslySinceBirth === '' ||
                formik.values.csu_info?.isLivedInCaliforniaContinuouslySinceBirth === null) &&
              check
            }
            disabled={disabled}
          />
        </Grid>
      )}

      {notLivedSinceBirth && (
        <>
          <Grid xs={12} md={6}>
            <DatePickerInput
              label="When did his/her current stay in California begin?*"
              name="csu_info.whenStayInCaliforniaBegin"
              values={formik.values.csu_info?.whenStayInCaliforniaBegin}
              onChange={(value) => formik.setFieldValue('csu_info.whenStayInCaliforniaBegin', value)}
              isMissing={!formik.values.csu_info?.whenStayInCaliforniaBegin && check}
              disabled={disabled}
            />
          </Grid>
          <Grid xs={12} md={6} />
          <Grid xs={12} md={6}>
            <SelectInput
              label="Prior Country*"
              option={priorCountryOptions}
              values={formik.values.csu_info?.priorCountry}
              name="csu_info.priorCountry"
              onChange={(e) => handlePriorCountryChange(e)}
              isMissing={!formik.values.csu_info?.priorCountry && check}
              disabled={disabled}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <SelectInput
              label="Prior State/Territory*"
              defautlValues="Select a State/Province"
              option={formik.values.csu_info?.priorStateOptions}
              values={formik.values.csu_info?.priorState}
              name="csu_info.priorState"
              onChange={formik.handleChange}
              isMissing={
                (!formik.values.csu_info?.priorState ||
                  formik.values.csu_info?.priorState === 'Select a State/Province') &&
                check
              }
              disabled={disabled}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <DatePickerInput
              label="From when to when did he/she live there*"
              name="csu_info.fromWhenToWhenLiveThere"
              values={formik.values.csu_info?.fromWhenToWhenLiveThere}
              onChange={(value) => formik.setFieldValue('csu_info.fromWhenToWhenLiveThere', value)}
              isMissing={!formik.values.csu_info?.fromWhenToWhenLiveThere && check}
              disabled={disabled}
              />
          </Grid>
          <Grid xs={12} md={6}>
            <DatePickerInput
              label="To*"
              name="csu_info.ToWhenToWhenLiveThere"
              values={formik.values.csu_info?.ToWhenToWhenLiveThere}
              onChange={(value) => formik.setFieldValue('csu_info.ToWhenToWhenLiveThere', value)}
              isMissing={!formik.values.csu_info?.ToWhenToWhenLiveThere && check}
              disabled={disabled}
              />
          </Grid>
        </>
      )}
      
    
    </>
  );
};

export default Residency;
